export default {
    resetState({commit}) {
        commit('resetStateMutation');
    },
    openForm({commit}) {
        commit('setFormOpenEprofileAktProblemak');
    },
    closeForm({commit}) {
        commit('setFormCloseEprofileAktProblemak');
    }
}
